/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue'
import Router from 'vue-router'
import Mgr from './services/SecurityService'
import i18n from 'vue-i18n'
import store from './store/store'

Vue.use(Router)
const mgr = new Mgr()

const CheckCustomerInfoLoaded = (to, from, next) => {
  function proceed () {
    if (store.state.AppActiveUser.customerId !== -1) {
      next()
    }
  }

  if (store.state.AppActiveUser.customerId === -1) {
    store.watch(
      (state) => state.AppActiveUser.customerId,
      (value) => {
        if (value !== -1) {
          proceed()
        }
      }
    )
  } else {
    proceed()
  }
}

const router = new Router({
  mode: 'history',
  // base: process.env.BASE_URL,
  base: '',
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [
    {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
      path: '',
      beforeEnter: CheckCustomerInfoLoaded,
      component: () => import('./layouts/main/Main.vue'),
      children: [
        {
          path: ':lang?/',
          redirect: 'dashboard/abstract'
        },
        { 
          path: ':https://www.google.com/',
          name: 'HomePage'
        },
        { 
          path: ':lang?/dashboard/Profile',
          name: 'ScaCustomer_Profile',
          component: () => import('./views/dashboard/customerProfile.vue'),
          meta: {
            rule: 'isSysAdmin'
          }
        },
        { 
          path: ':lang?/dashboard/AccountList',
          name: 'ScaCustomer_AccountList',
          component: () => import('./views/dashboard/customerAccountList.vue'),
          meta: {
            rule: 'isSysAdmin'
          }
        },
        { 
          path: ':lang?/dashboard/OrderList',
          name: 'ScaCustomer_OrderList',
          component: () => import('./views/dashboard/customerOrderList.vue'),
          meta: {
            rule: 'isSysAdmin'
          }
        },
        { 
          path: ':lang?/Dashboard/abstract',
          name: 'ScaCustomer_Dashboard',
          component: () => import('./views/dashboard/customerDashboard.vue'),
          meta: {
            pageTitle:'UserDashboard',
            rule: 'isSysAdmin'
          }
        },
        {
          path: ':lang?/transaction/deposit/add',
          name: 'makeDeposit',
          component: () => import('./views/transaction/deposit/makeDeposit.vue'),
          meta: {
            rule: 'isSysAdmin'
          }
        },            
        { 
          path: ':lang?/transaction/deposit/successful/:id',
          name: 'ScaCustomer_Successful',
          component: () => import('./views/transaction/deposit/depositSuccessful.vue'),
          meta: {
            rule: 'isSysAdmin'
          }
        },
        { 
          path: ':lang?/transaction/deposit/failed/:id',
          name: 'ScaCustomer_Failed',
          component: () => import('./views/transaction/deposit/depositFailed.vue'),
          meta: {
            rule: 'isSysAdmin'
          }
        },
        { 
          path: ':lang?/transaction/history',
          name: 'transactionHistory',
          component: () => import('./views/transaction/history.vue'),
          meta: {
            rule: 'isSysAdmin'
          }
        },
        { 
          path: ':lang?/transaction/withdrawal/add',
          name: 'makeWithdrawal',
          component: () => import('./views/transaction/withdrawal/makeWithdrawal.vue'),
          meta: {
            rule: 'isSysAdmin'
          }
        },
        { 
          path: ':lang?/transaction/transfer/add',
          name: 'makeTransfer',
          component: () => import('./views/transaction/transfer/makeTransfer.vue'),
          meta: {
            rule: 'isSysAdmin'
          }
        },            
        { 
          path: ':lang?/transaction/transfer/successful/:id',
          name: 'ScaCustomer_Successful',
          component: () => import('./views/transaction/deposit/depositSuccessful.vue'),
          meta: {
            rule: 'isSysAdmin'
          }
        },
        { 
          path: ':lang?/transaction/transfer/failed/:id',
          name: 'ScaCustomer_Failed',
          component: () => import('./views/transaction/deposit/depositFailed.vue'),
          meta: {
            rule: 'isSysAdmin'
          }
        },
        { 
          path: ':lang?/upload/document',
          name: 'ScaCustomer_Upload',
          component: () => import('./views/upload/index.vue'),
          meta: {
            rule: 'isSysAdmin'
          }
        },
        { 
          path: ':lang?/settings/thecustomizer',
          name: 'Settings',
          component: () => import('./views/Customizer.vue'),
          meta: {
            rule: 'isSysAdmin',
            authRequired: false
          }
        }
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: ':lang?/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue')
        },
        {
          path: ':lang?/pages/error-500',
          name: 'page-error-500',
          component: () => import('@/views/pages/Error500.vue')
        },
        {
          path: ':lang?/pages/not-authorized',
          name: 'page-not-authorized',
          component: () => import('@/views/pages/NotAuthorized.vue')
        },
        {
          path: ':lang?/pages/comingsoon',
          name: 'page-coming-soon',
          component: () => import('@/views/pages/ComingSoon.vue')
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: ':lang?/pages/error-404'
    }
  ]
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

router.beforeEach((to, from, next) => {
  if (to.params.lang === undefined) {
    return next({name: to.name, params: {lang: localStorage.Lang || 'en'}, query: to.query})
  }
  
  if (localStorage.Lang && to.params.lang !== localStorage.Lang) {
    i18n.locale = to.params.lang
    localStorage.Lang = to.params.lang
    //return next({name: to.name, params: {lang: localStorage.Lang || 'en'}, query: to.query})
  }
  const authRequired = to.matched.some(record => record.meta.authRequired)
  if (authRequired) {
    mgr.getRole().then(
      sucess => {
        console.error(sucess)
        next()
          if (to.meta.role == sucess){
          next();
        }else {
          next('/pages/error-404');
        }
      },
      err => {
        console.log(err)
      }
    )    
  } else {
    next()
  }
})

export default router
